import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderSearchService {
  private showHeaderSearch = new BehaviorSubject<boolean>(true);
  private locked = false;
  constructor() {

  }
    showHeaderSearch$ = this.showHeaderSearch.asObservable();

  setHeaderSearchState(value: boolean) {
    // When locked (e.g. a mobile dropdown anchored to the header is open),
    // ignore scroll-driven updates so the bar doesn't disappear under it.
    if (this.locked) {
      return;
    }
    this.showHeaderSearch.next(value);
  }

  lockVisible() {
    this.locked = true;
    this.showHeaderSearch.next(true);
  }

  unlock() {
    this.locked = false;
  }
}
